import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Button, Divider } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, FORMAT_NUMBER_NO_ZERO, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };

    handleFilter = (e) => {

        if (this.props.formValues.listaEmpleado.length > 0) {

            var filteredValue = this.props.formValues.listaEmpleado.filter(function (item) {
                return item.numeroDocumento == e;
            });

            if (filteredValue.length > 0) {

                this.props.onFilter(filteredValue)

            } else {
                dialog.error('No encontro el resultado');

            }
        } else {

            dialog.error('No encontro el resultado');

        }

    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {
                const form = {
                    id: values.id,
                    serie: values.serie,
                    correlativo: values.correlativo,
                    fechaTipoCambio: values.fechaTipoCambio.format("DD/MM/YYYY"),
                    tipoCambio: parseFloat(values.tipoCambio),
                    idEstablecimiento: values.idEstablecimiento.key,
                    idProyecto: values.idProyecto.key,
                    idCaja: values.idCaja.key,
                    idMoneda: values.idMoneda.key,
                    idEmpleado: values.idResponsable.key,
                    montoApertura: parseFloat(values.montoApertura),
                }

                const validFormLogic = this.validateFormLogic(form, values);
                if (!validFormLogic) {
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    validateFormLogic = (data, values) => {

        if (data.idEmpleado === 0) {
            dialog.warning("Responsable ingresado es invalido.");
            return false;
        }

        return true;
    };



    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Apertura de Caja Chica" : "Modificar Apertura de Caja Chica"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Serie Documento">

                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Serie"
                                                autoComplete="off"
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha Apertura">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("fechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.fechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item hidden={true} style={{ width: "35%" }}>
                                        {getFieldDecorator("tipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.tipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "tipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                    </div>



                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({
                                                idCaja: undefined,
                                            },
                                                () => { this.props.onChange(option.key, this.props.form) }
                                            );
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        disabled={this.props.loadingChange}
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.cajas.map((item) => (
                                            item.idTipoCaja == 2 ? <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option> : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <Form.Item label="Responsable de Manejo de Caja">
                                {getFieldDecorator("idResponsable", {
                                    initialValue: this.props.formValues.idResponsable
                                        ? { key: this.props.formValues.idResponsable }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        disabled={true}
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                        showArrow={false}
                                    >
                                        {this.props.formValues.empleados.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}

                                    </Select>
                                )}
                            </Form.Item>

                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Moneda">
                                {getFieldDecorator("idMoneda", {
                                    initialValue: this.props.formValues.idMoneda
                                        ? { key: this.props.formValues.idMoneda }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Monto de Apertura">
                                <InputGroup compact>
                                    <Form.Item>
                                        {getFieldDecorator(`montoApertura`, {
                                            initialValue: parseFloat(this.props.formValues.montoApertura).toFixed(2),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_2DECIMALS),
                                                message: "Formato (0.00)"
                                            },
                                            {
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: "Mayor a 0.00"
                                            }
                                            ]
                                        })(
                                            <Input
                                                placeholder="Monto Pen"
                                                autoComplete="off"
                                                onKeyPress={global.onKeyPressDecimals}
                                                onBlur={(e) => {
                                                    this.props.form.setFieldsValue({
                                                        montoApertura: global.onBlurDecimals(e, 2)
                                                    });
                                                }}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator("idProyecto", {
                                    initialValue: this.props.formValues.idProyecto
                                        ? { key: this.props.formValues.idProyecto }
                                        : 0,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)